// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"f8e292b6","225":"e4e651c9","227":"fb9efbd4","282":"fb9efbd4","294":"e74d3fe0","625":"fb9efbd4","771":"fb9efbd4","797":"fb9efbd4","882":"49453d3c","927":"e688602b","950":"fb9efbd4","980":"d1449952"}[chunkId] + ".chunk.css";
};